import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const localeParams = (params = {}) => (window.location.pathname === "/en" || window.location.pathname.startsWith("/en/") ? { ...params, lang: "en" } : params);

export const api = {
  products: (params) => axios.get(`${API}/products`, { params: localeParams(params) }).then((r) => r.data),
  product: (id) => axios.get(`${API}/products/${id}`, { params: localeParams() }).then((r) => r.data),
  articleTranslation: (slug) => axios.get(`${API}/articles/${slug}/translation`).then((r) => r.data),
  articleTranslations: (slugs) => axios.get(`${API}/articles/translations`, { params: { slugs: slugs.join(",") } }).then((r) => r.data),
  events: (params) => axios.get(`${API}/events`, { params: localeParams(params) }).then((r) => r.data),
  event: (id) => axios.get(`${API}/events/${id}`, { params: localeParams() }).then((r) => r.data),
  eventBySlug: (slug) => axios.get(`${API}/events/slug/${slug}`, { params: localeParams() }).then((r) => r.data),
  book: (payload) => axios.post(`${API}/bookings`, payload).then((r) => r.data),
  wyrdVerifier: (email) => axios.post(`${API}/wyrd/verifier`, { email }).then((r) => r.data),
  disponibilites: () => axios.get(`${API}/disponibilites`).then((r) => r.data),
  stagePricing: () => axios.get(`${API}/stage-pricing`).then((r) => r.data),
  stagePricingIndividuel: () => axios.get(`${API}/stage-pricing/individuel`).then((r) => r.data),
  stagePricingEvent: (id) => axios.get(`${API}/stage-pricing/events/${id}`).then((r) => r.data),
  tunnelTambour: () => axios.get(`${API}/tunnel-creer-son-tambour`).then((r) => r.data),
  avis: () => axios.get(`${API}/avis`).then((r) => r.data),
  realisations: (params) => axios.get(`${API}/realisations`, { params }).then((r) => r.data),
  order: (payload) => axios.post(`${API}/orders`, payload).then((r) => r.data),
  contact: (payload) => axios.post(`${API}/contact`, payload).then((r) => r.data),
  paymentStatus: (sessionId) => axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data),
  paymentResult: (sessionId) => axios.get(`${API}/payments/result/${sessionId}`).then((r) => r.data),
  paymentCancel: (sessionId) => axios.post(`${API}/payments/cancel/${sessionId}`).then((r) => r.data),
  giftcard: (code) => axios.get(`${API}/giftcards/${encodeURIComponent(code.trim().toUpperCase())}`).then((r) => r.data),
  buyGiftcard: (payload) => axios.post(`${API}/giftcards`, payload).then((r) => r.data),
  newsletter: (email) => axios.post(`${API}/newsletter`, { email }).then((r) => r.data),
  solde: (id) => axios.get(`${API}/bookings/${id}/solde`).then((r) => r.data),
  paySolde: (id, origin) => axios.post(`${API}/bookings/${id}/solde`, null, { params: { origin_url: origin } }).then((r) => r.data),
};

export const formatCHF = (n) =>
  new Intl.NumberFormat("fr-CH", { style: "currency", currency: "CHF", minimumFractionDigits: n % 1 ? 2 : 0 }).format(n);

export const formatDate = (iso, opts = {}) =>
  new Intl.DateTimeFormat("fr-CH", { weekday: "long", day: "numeric", month: "long", year: "numeric", ...opts }).format(new Date(iso));

export const formatTime = (iso) =>
  new Intl.DateTimeFormat("fr-CH", { hour: "2-digit", minute: "2-digit" }).format(new Date(iso));
